import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { DsAbstractLoadingComponent } from '@abstract/components/ds-abstract-loading.component';
import { DsLoadingSpinnerMetricPipe } from '@design-system/ds-loading-spinner/pipes/ds-loading-spinner-metric.pipe';

@Component({
  selector: 'ds-loading-spinner',
  standalone: true,
  imports: [NgClass, MatProgressSpinnerModule, DsLoadingSpinnerMetricPipe],
  templateUrl: './ds-loading-spinner.component.html',
  styleUrls: ['./ds-loading-spinner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DsLoadingSpinnerComponent extends DsAbstractLoadingComponent {
  /**
   * Optional circular diameter override in pixels. When set, it takes precedence over `size`.
   */
  @Input() diameter: number | null = null;

  /**
   * Optional circular stroke width override in pixels. When set, it takes precedence over `size`.
   */
  @Input() strokeWidth: number | null = null;
}
